import { toastsIntlIds } from './toasts.ids';

export const toastsLangEnUs = {
  [toastsIntlIds.onLoadingToast.title]: 'Action in progress',
  [toastsIntlIds.onLoadingToast.description]:
    'Please wait a few moments while we complete this action',
};
